import { Component, ComponentFactoryResolver, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { ComponentRef } from '@ionic/core';
import { DynamicComponents } from 'src/app/_directives/dynamic-component.directive';
import { FullscreenData, isFullscreenableProperty } from 'src/app/_interfaces/fullscreen';
import { NoConnectionPage } from 'src/app/_pages/no-connection/no-connection.page';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { FullscreenService } from 'src/app/_provider/fullscreen.service';
import { ResizeManagerService } from 'src/app/_provider/resize-manager.service';

@Component({
    selector: 'app-fullscreen-modal',
    templateUrl: './fullscreen-modal.component.html',
    styleUrls: ['./fullscreen-modal.component.scss'],
    standalone: false
})
export class FullscreenModalComponent {
  @ViewChild(DynamicComponents, {static: true}) dynamicComp!: DynamicComponents;



  constructor(
    private fullscrenSrv: FullscreenService,
    private resizeManager: ResizeManagerService
  ) {
    
    this.fullscrenSrv.modalFullscreenChange.subscribe((component: FullscreenData)=>{
      if(!component)return
      const viewContainerRef = this.dynamicComp?.viewContainerRef
      if(!viewContainerRef) return
      viewContainerRef.clear()
      if(!component.isOpen)return
      const componentRef = viewContainerRef.createComponent<typeof component.instance>(component.componentType);
      componentRef.instance.isFullscreen = true

      let keyList: string[] = []

      //alle holen die einen Fullscreen Decorator haben
      Reflect.ownKeys(component.instance).forEach((key: string)=>{
        if(isFullscreenableProperty(component.instance, key)) keyList.push(key)
      })
      keyList.forEach((key: string)=>componentRef.instance[key] = component.instance[key])
    })
  }

  ngOnInit(){
  }



}
